import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

// import UserEdit from './views/UserEdit.vue';


Vue.use(Router);


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [
    {
      path: '/emptypage',
      name: 'emptypage',
      component: require('@/views/EmptyPage').default
    },
    {
      path: '/',
      name: 'Sellinone',
      component: require('@/views/Sellinone').default
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    // login logoff redirects
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
    },
    {
      path: '/selectstore',
      name: 'selectstore',
      component: () => import(/* webpackChunkName: "about" */ './views/SelectStore.vue'),
    },


    // {
    //   path: '/',
    //   name: 'landingpage',
    //   component: require('@/views/LandingPage').default
    // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: require('@/views/Login').default
    // },
    {
      path: '/setting',
      name: 'setting',
      component: require('@/views/Setting').default
    },
    {
      path: '/sellinone',
      name: 'sellinone',
      component: require('@/views/Sellinone').default
    },
    {
      path: '/sell2',
      name: 'sell2',
      component: require('@/views/Sell2').default
    },
    {
      path: '/sellprint',
      name: 'sellprint',
      component: require('@/views/Sellprint').default
    },
    // {
    //   path: '/buyer',
    //   name: 'buyer',
    //   component: require('@/views/Buyer').default
    // },
    {
      path: '/buyer',
      name: 'buyer',
      component: require('@/views/Buyer').default
    },
    {
      path: '/businesspartner',
      name: 'businesspartner',
      component: require('@/views/BusinessPartner').default
    },
    {
      path: '/businesspartner/:id',
      name: 'businesspartner',
      props: true,
      component: require('@/views/BusinessPartner').default
    },
    {
      path: '/businesspartners',
      name: 'businesspartners',
      component: require('@/views/BusinessPartners').default
    },

    // SecondaryDisplay route, it opens a SecondaryDisplay component as a new window
    // {
    //   path: '/SecondaryDisplay',
    //   name: 'SecondaryDisplay',
    //   component: require('@/components/SecondaryDisplay').default,
    // },
    {
      path: '/closes',
      name: 'closes',
      component: require('@/views/Closes').default
    },
    {
      path: '/closesprint',
      name: 'closesprint',
      component: require('@/views/Closesprint').default
    },
    // {
    //   path: '/sellprint',
    //   name: 'sellprint',
    //   component: require('@/views/Sellprint').default
    // },
    // {
    //   path: '/setting',
    //   name: 'setting',
    //   component: require('@/views/Setting').default
    // },
    {
      path: '/transactions',
      name: 'transactions',
      component: require('@/views/Transactions').default
    },



  //   {
  //     path: '/forgottenpassword',
  //     name: 'forgottenpassword',
  //     component: () => import(/* webpackChunkName: "about" */ './views/Forgottenpassword.vue'),
  //   },
  //   {
  //     path: '/dashboard',
  //     name: 'dashboard',
  //     component: () => import('./views/Dashboard.vue'),
  //   },
  //   // Selling
  //   {
  //     path: '/seldashboard',
  //     name: 'seldashboard',
  //     component: () => import('./views/SelDashboard.vue'),
  //   },
  //   {
  //     path: '/selcharts',
  //     name: 'selcharts',
  //     component: () => import('./views/SelCharts.vue'),
  //   },
  //   {
  //     path: '/selproducts',
  //     name: 'selproducts',
  //     component: () => import('./views/SelProducts.vue'),
  //   },
  //   {
  //     path: '/selproduct',
  //     name: 'selproduct',
  //     component: () => import('./views/SelProduct.vue'),
  //     props: true
  //   },
  //   {
  //     path: '/selproduct/:id',
  //     name: 'selproduct',
  //     component: () => import('./views/SelProduct.vue'),
  //   },
  //   {
  //     path: '/selproductcategories',
  //     name: 'selproductcategories',
  //     component: () => import('./views/SelProductCategories.vue'),
  //   },
  //   {
  //     path: '/selproductcategory',
  //     name: 'selproductcategory',
  //     component: () => import('./views/SelProductCategory.vue'),
  //     props: true
  //   },
  //   {
  //     path: '/selproductcategory/:id',
  //     name: 'selproductcategory',
  //     component: () => import('./views/SelProductCategory.vue'),
  //   },
  //
  //
  //   {
  //     path: '/selbuyers',
  //     name: 'selbuyers',
  //     component: () => import('./views/SelBuyers.vue'),
  //   },
  //   {
  //     path: '/selbuyeredit',
  //     name: 'selbuyeredit',
  //     component: () => import('./views/SelBuyerEdit.vue'),
  //     props: true
  //   },
  //   {
  //     path: '/selbuyeredit/:id',
  //     name: 'selbuyeredit',
  //     component: () => import('./views/SelBuyerEdit.vue'),
  //   },
  //
  //   {
  //     path: '/seldiscountchooses',
  //     name: 'seldiscountchooses',
  //     component: () => import('./views/SelDiscountChooses.vue'),
  //   },
  //   {
  //     path: '/seldiscountchoose',
  //     name: 'seldiscountchoose',
  //     component: () => import('./views/SelDiscountChoose.vue'),
  //     props: true
  //   },
  //   {
  //     path: '/seldiscountchoose/:id',
  //     name: 'seldiscountchoose',
  //     component: () => import('./views/SelDiscountChoose.vue'),
  //   },
  //   {
  //     path: '/selsells',
  //     name: 'selsells',
  //     component: () => import('./views/SelSells.vue'),
  //   },
  //   {
  //     path: '/selsellview/:id',
  //     name: 'selsellview',
  //     component: () => import('./views/SelSellView.vue'),
  //   },
  //
  //   {
  //     path: '/selstores',
  //     name: 'selstores',
  //     component: () => import('./views/SelStores.vue'),
  //   },
  //   {
  //     path: '/selstore',
  //     name: 'selstores',
  //     component: () => import('./views/SelStore.vue'),
  //     props: true
  //   },
  //   {
  //     path: '/selstore/:id',
  //     name: 'selstore',
  //     component: () => import('./views/SelStore.vue'),
  //   },
  //
  //   {
  //     path: '/stostockalerts',
  //     name: 'stostockalerts',
  //     component: () => import('./views/StoStockAlerts.vue'),
  //   },
  //   {
  //     path: '/worworklogs',
  //     name: 'worworklogs',
  //     component: () => import('./views/WorWorklogs.vue'),
  //   },
  //   {
  //     path: '/wordaylogs',
  //     name: 'wordaylogs',
  //     component: () => import('./views/WorDaylogs.vue'),
  //   },
  //
  //   {
  //     path: '/selworkstations',
  //     name: 'selworkstations',
  //     component: () => import('./views/SelWorkstations.vue'),
  //   },
  //   {
  //     path: '/selworkstation',
  //     name: 'selworkstation',
  //     component: () => import('./views/SelWorkstation.vue'),
  //     props: true
  //   },
  //   {
  //     path: '/selworkstation/:id',
  //     name: 'selworkstation',
  //     component: () => import('./views/SelWorkstation.vue'),
  //   },
  //   {
  //     path: '/selc',
  //     name: 'selc',
  //     component: () => import('./views/SelC.vue'),
  //   },
  //
  // // selsettings
  //   {
  //     path: '/selsettings',
  //     name: 'selsettings',
  //     component: () => import('./views/SelSettings.vue'),
  //   },
  //   // {
  //   //   path: '/selsetting',
  //   //   name: 'selsetting',
  //   //   component: () => import('./views/SelSetting.vue'),
  //   //   props: true
  //   // },
  //   // {
  //   //   path: '/selsetting/:id',
  //   //   name: 'selsetting',
  //   //   component: () => import('./views/SelSetting.vue'),
  //   // },
  //   // selscontents
  //   {
  //     path: '/selcontents',
  //     name: 'selcontents',
  //     component: () => import('./views/SelContents.vue'),
  //   },
  //   {
  //     path: '/selcontent',
  //     name: 'selcontent',
  //     component: () => import('./views/SelContent.vue'),
  //     props: true
  //   },
  //   {
  //     path: '/selcontent/:id',
  //     name: 'selcontent',
  //     component: () => import('./views/SelContent.vue'),
  //   },
  //
  //   // User and profile
  //   {
  //     path: '/usermyprofile',
  //     name: 'usermyprofile',
  //     component: () => import('./views/UserMyProfile.vue'),
  //   },
  //   {
  //     path: '/usersettings',
  //     name: 'usersettings',
  //     component: () => import('./views/UserSettings.vue'),
  //   },
  //   {
  //     path: '/users',
  //     name: 'users',
  //     component: () => import('./views/Users.vue'),
  //   },
  //   {
  //     path: '/useredit/:id',
  //     name: 'useredit',
  //     component: UserEdit,
  //     props: true ,
  //   },
  //   {
  //     path: '/useredit/',
  //     name: 'useredit',
  //     component: () => import('./views/UserEdit.vue'),
  //   },
  //
  //
  //   {
  //     path: '/cloudusers',
  //     name: 'cloudusers',
  //     component: () => import('./views/CloudUsers.vue'),
  //   },
  //   {
  //     path: '/clouduser/:id',
  //     name: 'clouduser',
  //     component: () => import('./views/CloudUser.vue'),
  //   },
  //   {
  //     path: '/clouduser/',
  //     name: 'clouduser',
  //     component: () => import('./views/CloudUser.vue'),
  //   },
  //
  //   {
  //     path: '/stodeliverynotes',
  //     name: 'stodeliverynotes',
  //     component: () => import('./views/StoDeliveryNotes.vue'),
  //   },
  //   {
  //     path: '/stodeliverynote/:id',
  //     name: 'stodeliverynote',
  //     component: () => import('./views/StoDeliveryNote.vue'),
  //   },
  //   {
  //     path: '/stodeliverynote/',
  //     name: 'stodeliverynote',
  //     component: () => import('./views/StoDeliveryNote.vue'),
  //   },
  //
  //
  //   {
  //     path: '/storevenue/',
  //     name: 'storevenue',
  //     component: () => import('./views/StoRevenue.vue'),
  //   },
  //   {
  //     path: '/storevenue/:id',
  //     name: 'storevenue',
  //     component: () => import('./views/StoRevenue.vue'),
  //   },
  //   {
  //     path: '/storevenues',
  //     name: 'storevenues',
  //     component: () => import('./views/StoRevenues.vue'),
  //   },









    //
    //    {
    //      path: '/stobuyerorders',
    //      name: 'stobuyerorders',
    //      component: () => import('./views/StoBuyerorders.vue'),
    //    },
    //    {
    //      path: '/stobuyerorder/:id',
    //      name: 'stobuyerorder',
    //      component: () => import('./views/StoBuyerorder.vue'),
    //    },
    //    {
    //      path: '/stobuyerorder/',
    //      name: 'stobuyerorder',
    //      component: () => import('./views/StoBuyerorder.vue'),
    //    },
    //
    //    {
    //      path: '/stoorders',
    //      name: 'stoorders',
    //      component: () => import('./views/StoOrders.vue'),
    //    },
    //    {
    //      path: '/stoorder/:id',
    //      name: 'stoorder',
    //      component: () => import('./views/StoOrder.vue'),
    //    },
    //    {
    //      path: '/stoorder/',
    //      name: 'stoorder',
    //      component: () => import('./views/StoOrder.vue'),
    //    },
    //
    //    {
    //      path: '/storevenues',
    //      name: 'storevenues',
    //      component: () => import('./views/StoRevenues.vue'),
    //    },
    //    {
    //      path: '/storevenue/:id',
    //      name: 'storevenue',
    //      component: () => import('./views/StoRevenue.vue'),
    //    },
    //    {
    //      path: '/storevenue/',
    //      name: 'storevenue',
    //      component: () => import('./views/StoRevenue.vue'),
    //    },
    //
    //
    //
    //    {
    //      path: '/invinvoices',
    //      name: 'invinvoices',
    //      component: () => import('./views/InvInvoices.vue'),
    //    },
    //    {
    //      path: '/invinvoice/:id',
    //      name: 'invinvoice',
    //      component: () => import('./views/InvInvoice.vue'),
    //    },
    //    {
    //      path: '/invinvoice/',
    //      name: 'invinvoice',
    //      component: () => import('./views/InvInvoice.vue'),
    //    },
    //
    //
    //
    //









    // {
    //   path: '/crmbusinesspartners',
    //   name: 'crmbusinesspartner',
    //   component: () => import('./views/CrmBusinessPartners.vue'),
    // },
    // {
    //   path: '/crmbusinesspartner/:id',
    //   name: 'crmbusinesspartner',
    //   component: () => import('./views/CrmBusinessPartner.vue'),
    // },
    // {
    //   path: '/crmbusinesspartner/',
    //   name: 'crmbusinesspartner',
    //   component: () => import('./views/CrmBusinessPartner.vue'),
    // },
    // {
    //   path: '/companydata/',
    //   name: 'companydata',
    //   component: () => import('./views/CompanyData.vue'),
    // },
    // {
    //   path: '/crmcontacts',
    //   name: 'crmcontacts',
    //   component: () => import('./views/CrmContacts.vue'),
    // },
    // {
    //   path: '/crmcontact/:id',
    //   name: 'crmcontact',
    //   component: () => import('./views/CrmContact.vue'),
    // },
    // {
    //   path: '/crmcontact/',
    //   name: 'crmcontact',
    //   component: () => import('./views/CrmContact.vue'),
    // },
    // {
    //   path: '/crmcontact/',
    //   name: 'crmcontactParams',
    //   props: true,
    //   component: () => import('./views/CrmContact.vue'),
    // },
    // {
    //   path: '/crmaddress/:id',
    //   name: 'crmaddress',
    //   props: true,
    //   component: () => import('./views/CrmAddress.vue'),
    // },
    // {
    //   path: '/crmaddress/',
    //   name: 'crmaddress',
    //   props: true,
    //   component: () => import('./views/CrmAddress.vue'),
    // },
    // {
    //   path: '/crmaddress/',
    //   name: 'crmaddressParams',
    //   props: true,
    //   component: () => import('./views/CrmAddress.vue'),
    // },
    //
    //
    // {
    //   path: '/offoffers',
    //   name: 'offoffers',
    //   component: () => import('./views/OffOffers.vue'),
    // },
    // {
    //   path: '/offoffer/:id',
    //   name: 'offoffer',
    //   props: true,
    //   component: () => import('./views/OffOffer.vue'),
    // },
    // {
    //   path: '/offoffer/',
    //   name: 'offoffer',
    //   props: true,
    //   component: () => import('./views/OffOffer.vue'),
    // },
    // {
    //   path: '/selvats',
    //   name: 'selvats',
    //   component: () => import('./views/SelVats.vue'),
    // },
    // {
    //   path: '/selvat/:id',
    //   name: 'selvat',
    //   props: true,
    //   component: () => import('./views/SelVat.vue'),
    // },
    // {
    //   path: '/selvat/',
    //   name: 'selvat',
    //   props: true,
    //   component: () => import('./views/SelVat.vue'),
    // },

  ],
});
